module.exports = __webpack_public_path__ + "img/other.8c6071c7.png";